module.exports = __webpack_public_path__ + "img/heading-repeat.98040211.svg";